<template>
  <div>
    <div>
      <ValidationObserver ref="formCreateAlarm">
        <div class="flex flex-wrap">
          <div class="w-full md:w-1/3 px-2">
            <BaseInput v-model.trim="unit_info.name" type="text" :field_name="$t('alarm_create.unit_name')" readonly disabled />
          </div>
          <div class="w-full md:w-1/3 px-2">
            <BaseInput v-model.trim="unit_info.company_number" type="text" :field_name="$t('alarm_create.org_number')" readonly disabled />
          </div>
          <div class="w-full md:w-1/3 px-2">
            <div class="flex flex-wrap">
              <div v-if="!new RegExp('(SRT334)|(SRT330)|(TWIG Beacon)|(4G Box)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX (?!Hub))|(SecurDesktop)').test(device_type)" class="w-full md:w-1/3">
                <BaseSwitch v-model="gps_active" :field_name="$t('alarm_create.securtrack')" />
              </div>
              <div v-if="!new RegExp('(SRT334)|(SRT330)|(TWIG Beacon)|(4G Box)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX (?!Hub))|(SecurDesktop)').test(device_type)" class="w-full md:w-1/3">
                <BaseSwitch v-model="gps_log_active" :field_name="$t('alarm_create.securtool')" />
              </div>
            </div>
          </div>
        </div>

        <div class="mx-2 border-b border-secondary-400 my-5"></div>

        <div class="flex flex-wrap">
          <div class="w-full md:w-1/3 px-2">
            <BaseSelect v-model="device_type" :options="devices" :field_name="$t('alarm_create.device_type')" rules="required" @change="filterOrders()" />
          </div>
          <div class="w-full md:w-1/3 px-2">
            <BaseSelect v-model="order_id" :options="orders_filtered" nameSelector="modelnumber" optionSelector="_id" :field_name="$t('alarm_create.delivery_document')" @change="populateFieldFromOrder()" />
          </div>
          <!-- SEC-364 A13 / SEC-373: the inventory number sits in the top right cell,
               as in the alarm action report. All alarm centrals. -->
          <div class="w-full md:w-1/3 px-2" v-if="!new RegExp('(SRT334)|(TWIG Beacon)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX)|(SecurDesktop)').test(device_type)">
            <BaseInput v-model.trim="inventory_number" type="text" :field_name="$t('alarm_create.inventory_number')" />
          </div>
        </div>
        <div class="flex flex-wrap">
          <!-- the IMEI opens the row of hardware identifiers -->
          <div class="w-full md:w-1/3 px-2" v-if="!new RegExp('(SRT334)|(TWIG Beacon)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX)|(SecurDesktop)').test(device_type)">
            <BaseInput v-model.trim="imei_number" type="text" :field_name="$t('alarm_create.imei')" rules="required" />
          </div>
          <div class="w-full md:w-1/3 px-2" v-if="!new RegExp('(SRT334)|(TWIG Beacon)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX (?!Hub))|(SecurDesktop)').test(device_type)">
            <BaseInput v-model.trim="alarm_phone_number" type="text" :field_name="$t('alarm_create.telematic_number')" rules="required" />
          </div>
          <div class="w-full md:w-1/3 px-2" v-if="!new RegExp('(Avigilon Alta Compact Dome 5MP)|(SecurDesktop)').test(device_type)">
            <BaseInput v-model.trim="serial_number" type="text" :field_name="$t('alarm_create.serial_number')" rules="required" />
          </div>

          <div class="w-full md:w-1/3 px-2" v-if="new RegExp('(Avigilon Alta Compact Dome 5MP)').test(device_type)">
            <BaseInput v-model.trim="ava_flex.tag_serial_number" type="text" :field_name="$t('alarm_create.tag_serial_number')" rules="required" />
          </div>
          <div class="w-full md:w-1/3 px-2" v-if="new RegExp('(Avigilon Alta Compact Dome 5MP)').test(device_type)">
            <BaseInput v-model.trim="ava_flex.webhook" type="text" :field_name="$t('alarm_create.webhook')" rules="required" />
          </div>
          <div class="w-full md:w-1/3 px-2" v-if="new RegExp('(Avigilon Alta Compact Dome 5MP)').test(device_type)">
            <BaseInput v-model.trim="ava_flex.camera_token" type="text" :field_name="$t('alarm_create.token')" rules="required" />
          </div>

          <div class="w-full md:w-1/3 px-2" v-if="!new RegExp('(SRT334)|(SRT330)|(TWIG Beacon)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX (?!Hub))|(SecurDesktop)').test(device_type)">
            <BaseSelect v-model="operator" :options="sim_operators" :field_name="$t('alarm_create.operator_simcard')" rules="required" />
          </div>
        </div>
        <div class="mx-2 border-b border-secondary-400 my-5"></div>

        <div class="flex flex-wrap" v-if="!new RegExp('(SRT334)|(SRT330)|(TWIG Beacon)|(^TELTONIKA)|(4G Box)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX)|(SecurDesktop)').test(device_type)">
          <div class="w-full md:w-1/3 px-2">
            <BaseSelect v-model="alarm_central" :options="[{ name: $t('alarm_create.none'), _id: '-' }, ...alarm_centrals]" nameSelector="name" optionSelector="_id" :field_name="$t('alarm_create.alarm_central')" :rules="device_type === 'SRT430' && send_to_alarm_center ? 'required|oneOf:' + alarm_centrals.map((a) => a._id).join(',') : 'required'" @change="check_alarm_center_specifics()" />
            <!-- SEC-337: IMSI number, directly under the alarm centre it belongs to,
                 as on the edit form. Only for Securitas Sverige AB. -->
            <div class="mt-2" v-if="showImsiNumber">
              <BaseInput v-model.trim="imsi_number" type="text" :field_name="$t('change_alarm_plan.imsi_number')" />
            </div>
          </div>
          <div class="w-full md:w-1/3 px-2" v-if="show_alarm_number">
            <label class="text-gray-600 text-sm font-bold pb-2 font-serif">{{ $t('alarm_create.alarm_number') }}<b class="text-red-500 ml-1">*</b></label>
            <div class="flex">
              <input 
                v-model.trim="alarm_number" 
                type="text" 
                class="bg-gray-100 text-sm text-gray-900 focus:outline-none border-b-4 border-gray-300 hover:border-gray-400 transition duration-500 px-3 pt-2 pb-2 disabled:opacity-50 flex-grow rounded-l"
              />
              <button 
                v-if="isNorwegianSite"
                type="button"
                @click="regenerateAlarmNumberFromSerial"
                class="px-3 bg-primary-500 hover:bg-primary-600 text-white rounded-r border-b-4 border-primary-600 transition-colors"
                :title="$t('alarm_create.regenerate_alarm_number')"
              >
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
              </button>
            </div>
          </div>
          <div class="w-full md:w-1/3 px-2">
            <BaseSwitch v-model="man_down" :field_name="$t('alarm_create.man_down')" />
          </div>
          <div class="w-full md:w-1/3 px-2" v-if="showDirectDispatch">
            <BaseSwitch v-model="direct_dispatch" :field_name="$t('alarm_create.direct_dispatch')" />
          </div>
          <!-- SEC-339: the security company is entered only under "Extern åtgörare"
               below, which is the one the PDF prints -->
        </div>

        <div class="mx-2 border-b border-secondary-400 my-5" v-if="!new RegExp('(SRT334)|(SRT330)|(TWIG Beacon)|(^TELTONIKA)|(4G Box)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX)|(SecurDesktop)').test(device_type)"></div>

        <!-- SEC-364 A14: one row container, so cash agreement, unit status and the
             agreement fields fill two rows instead of three. All alarm centrals. -->
        <div class="flex flex-wrap mb-5">
          <div class="w-full md:w-1/3 px-2">
            <label class="inline-flex items-center mt-3">
              <input v-model="cash_agreement" :value="cash_agreement" type="checkbox" class="form-checkbox h-4 w-4" @change="switchAgreement()" />
              <span class="ml-2 text-sm font-sans font-semibold">{{ $t('alarm_create.cash_agreement') }}</span>
            </label>
          </div>
          <div class="w-full md:w-1/3 px-2">
            <BaseSelect v-model="device_status" :options="deviceStatuses" nameSelector="label" optionSelector="value" :field_name="$t('device_status.label')" rules="required" />
          </div>
          <div class="w-full md:w-1/3 px-2" v-if="cash_agreement">
            <BaseInput v-model="agreement_number" type="text" :field_name="$t('alarm_create.agreement_number')" readonly disabled />
          </div>
          <div class="w-full md:w-1/3 px-2" v-if="cash_agreement">
            <BaseInput v-model="agreement_length" type="text" :field_name="$t('alarm_create.agreement_length')" readonly disabled />
          </div>
          <div class="w-full md:w-1/3 px-2" v-if="!cash_agreement">
            <BaseInput v-model.trim="agreement_number" type="text" :field_name="$t('alarm_create.agreement_number')" rules="required" :placeholder="agreementNumberMask" />
          </div>
          <div class="w-full md:w-1/3 px-2" v-if="!cash_agreement">
            <BaseInput v-model.trim="agreement_length" type="text" :field_name="$t('alarm_create.agreement_length')" rules="required" />
          </div>
          <div class="w-full md:w-1/3 px-2">
            <BaseSelect v-model="seller" :options="sellers" nameSelector="name" optionSelector="_id" :field_name="$t('alarm_create.seller')" />
          </div>
          <!-- SEC-321: Avtalspart (contract party) — only for Westra + Commuter Security Group AB (CSG) -->
          <div class="w-full md:w-1/3 px-2" v-if="showContractParty">
            <BaseSelect v-model="contractPartyChoice" :options="[{ name: 'Commuter Security Group AB (CSG)', value: 'Commuter Security Group AB (CSG)' }, { name: $t('alarm_create.none'), value: 'none' }]" nameSelector="name" optionSelector="value" :field_name="$t('alarm_create.avtalspart')" />
          </div>
        </div>

        <div class="mx-2 border-b border-secondary-400 my-5"></div>

        <div class="flex flex-wrap">
          <div class="w-full md:w-1/3 px-2">
            <BaseInput v-model="delivery_company.name" type="text" :field_name="$t('alarm_create.company')" readonly disabled />
          </div>
          <div class="w-full md:w-1/3 px-2">
            <BaseInput v-model="delivery_company.phone" type="text" :field_name="$t('alarm_create.phone')" readonly disabled />
          </div>
          <div class="w-full md:w-1/3 px-2">
            <BaseInput v-model="delivery_company.email" type="text" :field_name="$t('alarm_create.email')" readonly disabled />
          </div>
        </div>

        <div class="mx-2 border-b border-secondary-400 my-5"></div>

        <div class="flex flex-wrap" v-if="!new RegExp('(SRT334)|(SRT330)|(TWIG Beacon)|(^TELTONIKA)|(4G Box)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX)|(SecurDesktop)').test(device_type)">
          <div class="w-full md:w-1/3 px-2">
            <BaseSelect v-model="selected_alarm_sort" :options="safe4AlarmSortChoices(alarmSortOptions, isSafe4Selected)" nameSelector="label" optionSelector="value" :field_name="$t('alarm_create.personal_group_alarm')" rules="required" @change="check_personal_alarm()" />
          </div>
          <div class="w-full md:w-1/3 px-2">
            <BaseSelect v-model="risk_profile" :options="riskProfileOptions" nameSelector="label" optionSelector="value" rules="required" :field_name="$t('alarm_create.risk_profile')" v-if="!show_MSL_risk"/>
            <BaseSelect v-model="risk_profile" :options="riskProfileOptionsMSL" nameSelector="label" optionSelector="value" rules="required" :field_name="$t('alarm_create.risk_profile')" v-if="show_MSL_risk"/>
          </div>
          <div class="w-full md:w-1/3 px-2">
            <BaseInput v-model="user" type="number" rules="required" :field_name="$t('alarm_create.number_of_users')" />
          </div>
        </div>

        <div class="flex flex-wrap" v-if="risk_profile == 'assault' || risk_profile == 'threat'">
          <div class="w-full md:w-1/3 px-2">
            <BaseInput v-model="reference_number" type="text" :field_name="$t('alarm_create.reference_number')" />
          </div>
        </div>

        <div class="flex flex-wrap" v-if="show_personal_alarm && !isSafe4Selected && !new RegExp('(SRT334)|(SRT330)|(TWIG Beacon)|(^TELTONIKA)|(4G Box)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX)|(SecurDesktop)').test(device_type)">
          <div class="w-full md:w-1/3 px-2">
            <BaseInput v-model="personal_alarm.reporting" type="text" :field_name="$t('alarm_create.reporting')" rules="required" />
          </div>
          <div class="w-full md:w-1/3 px-2">
            <BaseInput v-model="personal_alarm.name" type="text" :field_name="$t('alarm_create.name')" rules="required" />
          </div>
          <div class="w-full md:w-1/3 px-2">
            <BaseInput v-model="personal_alarm.home_address" type="text" :field_name="$t('alarm_create.home_address')" rules="required" />
          </div>
          <div class="w-full md:w-1/3 px-2">
            <BaseSelect v-model="personal_alarm.transport" :options="transportOptions" nameSelector="label" optionSelector="value" :field_name="$t('alarm_create.transport')" />
          </div>
          <div class="w-full md:w-1/3 px-2" v-if="personal_alarm.transport == 'car'">
            <BaseInput v-model="personal_alarm.registration_number" type="text" :field_name="$t('alarm_create.registration_number')" rules="required" />
          </div>
          <div class="w-full md:w-1/3 px-2" v-if="personal_alarm.transport == 'car'">
            <BaseInput v-model="personal_alarm.model" type="text" :field_name="$t('alarm_create.model')" rules="required" />
          </div>
          <div class="w-full md:w-1/3 px-2" v-if="personal_alarm.transport == 'car'">
            <BaseInput v-model="personal_alarm.color" type="text" :field_name="$t('alarm_create.color')" rules="required" />
          </div>
        </div>

        <div class="mx-2 border-b border-secondary-400 my-5" v-if="!new RegExp('(SRT334)|(SRT330)|(TWIG Beacon)|(^TELTONIKA)|(4G Box)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX)|(SecurDesktop)').test(device_type)"></div>

        <div class="flex flex-wrap">
          <div class="w-full md:w-1/3 px-2">
            <BaseInput v-model="alarm_name" type="text" rules="required" :field_name="$t('alarm_create.product_name')" />
          </div>
          <div class="w-full md:w-1/3 px-2" v-if="!isSafe4Selected && !new RegExp('(SRT334)|(SRT330)|(TWIG Beacon)|(^TELTONIKA)|(4G Box)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX)|(SecurDesktop)').test(device_type)">
            <BaseInput v-model="from_address.city" type="text" rules="required" :field_name="$t('alarm_create.starts_from_address')" />
          </div>
          <div class="w-full md:w-1/3 px-2" v-if="!new RegExp('(SRT334)|(SRT330)|(TWIG Beacon)|(^TELTONIKA)|(4G Box)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX)|(SecurDesktop)').test(device_type)">
            <BaseInput v-model="alarm_unit_name" type="text" rules="required" :field_name="$t('alarm_create.unit_name')" />
          </div>
          <!-- Safe-4 (SEC-364 A12): street, postal code and city belong together,
               so they get a row of their own instead of wrapping across two.
               Splitting them also keeps the KUIS postkode a clean value (req 8). -->
          <template v-if="isSafe4Selected">
            <div class="w-full flex flex-wrap">
              <div class="w-full md:w-1/3 px-2">
                <BaseInput v-model="from_address.street" type="text" rules="required|max:30" maxlength="30" :field_name="$t('safe4_form.street')" />
              </div>
              <div class="w-full md:w-1/3 px-2">
                <BaseInput v-model="from_address.zip" type="text" :rules="safe4PostcodeRules" :field_name="$t('safe4_form.postal_code')" />
              </div>
              <div class="w-full md:w-1/3 px-2">
                <BaseInput v-model="from_address.city" type="text" rules="required" :field_name="$t('safe4_form.city')" />
              </div>
            </div>
          </template>
          <div class="w-full md:w-1/3 px-2" v-if="!new RegExp('(SRT334)|(SRT330)|(TWIG Beacon)|(^TELTONIKA)|(4G Box)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX)|(SecurDesktop)').test(device_type)">
            <BaseTextarea rows="5" v-model="business_description" :field_name="$t('alarm_create.business_description')" rules="required" />
          </div>
          <div class="w-full md:w-1/3 px-2" v-if="device_type == 'SRT330' || device_type == 'SRT430'">
            <BaseTextarea rows="5" v-model="comment" :field_name="$t('alarm_create.comment')" />
          </div>
        </div>

        <div class="mx-2 border-b border-secondary-400 my-5"></div>

        <div class="flex flex-wrap" v-if="!new RegExp('(SRT334)|(SRT330)|(TWIG Beacon)|(^TELTONIKA)|(4G Box)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX)|(SecurDesktop)').test(device_type)">
          <div class="w-full text-xs italic px-2 mb-2">
            {{ isSosAlarm ? $t('alarm_create.password_info_sos') : $t('alarm_create.password_info') }}
          </div>
          <div class="w-full md:w-1/3 px-2">
            <!-- demo feedback: passwords are capped at 10 characters -->
            <BaseInput v-model="alarm_password" vid="alarm-password" type="text" :rules="isSafe4Selected ? 'required|max:20|safe4_password' : 'required'" :field_name="isSosAlarm ? $t('alarm_create.password_sos') : $t('alarm_create.password')" :maxlength="isSafe4Selected ? 20 : 200" />
            <!-- SEC-373: Safe-4 stops at 20 characters, so the 200 hint is not shown for it -->
            <p class="text-xs italic text-gray-500 mt-1" v-if="!isSafe4Selected">{{ $t('admin_order_alarm.password_hint') }}</p>
          </div>
          <!-- Safe-4 (SEC-364 A5): KUIS has no personal password, so the field is
               hidden and its value cleared when Safe-4 is the alarm central. -->
          <div class="w-full md:w-1/3 px-2" v-if="!isSafe4Selected">
            <BaseInput v-model="personal_password" type="text" :field_name="isSosAlarm ? $t('alarm_create.personal_password_sos') : $t('alarm_create.personal_password')" maxlength="200" />
            <p class="text-xs italic text-gray-500 mt-1">{{ $t('admin_order_alarm.password_hint') }}</p>
          </div>
        </div>

        <div class="mx-2 border-b border-secondary-400 my-5" v-if="!new RegExp('(SRT334)|(SRT330)|(TWIG Beacon)|(^TELTONIKA)|(4G Box)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX)|(SecurDesktop)').test(device_type)"></div>

        <div class="flex flex-wrap" v-if="!new RegExp('(SRT334)|(SRT330)|(TWIG Beacon)|(^TELTONIKA)|(4G Box)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX)|(SecurDesktop)').test(device_type)">
          <div class="w-full text-xs italic px-2 mb-2">
            {{ $t('alarm_create.external_contractor') }}
          </div>
          <div class="w-full md:w-1/3 px-2">
            <BaseInput v-model="external_contractor.name" type="text" :field_name="$t('alarm_create.name')" />
          </div>
          <div class="w-full md:w-1/3 px-2">
            <BaseInput v-model="external_contractor.phone" type="text" :field_name="$t('alarm_create.contact_number')" />
          </div>
          <div class="w-full md:w-1/3 px-2">
            <BaseInput v-model="external_contractor.object_id" type="text" :field_name="$t('alarm_create.object_id')" />
          </div>
        </div>

        <div class="mx-2 border-b border-secondary-400 my-5" v-if="!new RegExp('(SRT334)|(SRT330)|(TWIG Beacon)|(^TELTONIKA)|(4G Box)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX)|(SecurDesktop)').test(device_type)"></div>

        <div class="flex flex-wrap" v-if="!new RegExp('(SRT334)|(SRT330)|(TWIG Beacon)|(^TELTONIKA)|(4G Box)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX)|(SecurDesktop)').test(device_type)">
          <div class="w-full text-sm font-bold px-2 mb-2">
            {{ $t('alarm_create.contact_persons') }}
          </div>
          <div class="w-full text-xs italic px-2 mb-2">
            <p>{{ $t('alarm_create.contact_info') }}</p>

            <ol>
              <li>{{ $t('alarm_create.contact_example_1') }}</li>
              <li>{{ $t('alarm_create.contact_example_2') }}</li>
            </ol>
          </div>
          <!-- Safe-4 (SEC-364 A4): the contact persons are called around the clock,
               so the time fields hold the whole day. The note sits above them, in italics. -->
          <div class="w-full px-2 text-xs italic mb-1" v-if="isSafe4Selected">
            {{ $t("safe4_form.around_clock") }}
          </div>
          <div class="w-full flex flex-wrap" v-if="!new RegExp('(SRT334)|(SRT330)|(TWIG Beacon)|(^TELTONIKA)|(4G Box)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX)|(SecurDesktop)').test(device_type)">
            <div class="w-full md:w-3/12 px-2">
              <BaseInput v-model="contact_persons[0].name" type="text" :rules="isSafe4Selected ? 'required|max:50' : 'required'" :maxlength="isSafe4Selected ? 50 : undefined" :field_name="$t('alarm_create.name')" :placeholder="$t('alarm_create.name')" />
            </div>
            <div class="w-full md:w-3/12 px-2">
              <BaseInput v-model="contact_persons[0].function" type="text" :rules="isSafe4Selected ? 'required|max:40' : 'required'" :maxlength="isSafe4Selected ? 40 : undefined" :field_name="$t('alarm_create.function')" :placeholder="$t('alarm_create.function')" />
            </div>
            <div class="w-full md:w-3/12 px-2">
              <BasePhoneInput v-model="contact_persons[0].phone" vid="contact-phone-0" :show_country="isSafe4Selected" :rules="safe4PhoneRules(contact_persons, 0, isSafe4Selected, true)" :maxlength="isSafe4Selected ? 20 : undefined" :field_name="$t('alarm_create.number')" :placeholder="$t('alarm_create.number')" />
            </div>
            <div class="w-full md:w-1/12 px-2">
              <BaseInput v-model="contact_persons[0].weekday" type="text" :disabled="isSafe4Selected" :field_name="$t('alarm_create.weekday')" :placeholder="$t('alarm_create.weekday')" />
            </div>
            <div class="w-full md:w-1/12 px-2">
              <BaseInput v-model="contact_persons[0].saturday" type="text" :disabled="isSafe4Selected" :field_name="$t('alarm_create.saturday')" :placeholder="$t('alarm_create.saturday')" />
            </div>
            <div class="w-full md:w-1/12 px-2">
              <BaseInput v-model="contact_persons[0].sunday" type="text" :disabled="isSafe4Selected" :field_name="$t('alarm_create.sunday_holiday')" :placeholder="$t('alarm_create.sunday_holiday')" />
            </div>
          </div>
          <div class="w-full" v-for="(c, i) in contact_persons" :key="i">
            <div class="flex flex-wrap" v-if="i > 0">
              <div class="w-full md:w-3/12 px-2">
                <BaseInput v-model="c.name" type="text" :rules="isSafe4Selected ? 'max:50' : ''" :maxlength="isSafe4Selected ? 50 : undefined" :placeholder="$t('alarm_create.name')" />
              </div>
              <div class="w-full md:w-3/12 px-2">
                <BaseInput v-model="c.function" type="text" :rules="isSafe4Selected ? 'max:40' : ''" :maxlength="isSafe4Selected ? 40 : undefined" :placeholder="$t('alarm_create.function')" />
              </div>
              <div class="w-full md:w-3/12 px-2">
                <BasePhoneInput v-model="c.phone" :vid="'contact-phone-' + i" :show_country="isSafe4Selected" :rules="safe4PhoneRules(contact_persons, i, isSafe4Selected, false)" :maxlength="isSafe4Selected ? 20 : undefined" :placeholder="$t('alarm_create.number')" />
              </div>
              <div class="w-full md:w-1/12 px-2">
                <BaseInput v-model="c.weekday" type="text" :disabled="isSafe4Selected" :placeholder="$t('alarm_create.weekday')" />
              </div>
              <div class="w-full md:w-1/12 px-2">
                <BaseInput v-model="c.saturday" type="text" :disabled="isSafe4Selected" :placeholder="$t('alarm_create.saturday')" />
              </div>
              <div class="w-full md:w-1/12 px-2">
                <BaseInput v-model="c.sunday" type="text" :disabled="isSafe4Selected" :placeholder="$t('alarm_create.sunday_holiday')" />
              </div>
            </div>
          </div>
        </div>

        <div class="mx-2 border-b border-secondary-400 my-5" v-if="!new RegExp('(SRT334)|(SRT330)|(TWIG Beacon)|(^TELTONIKA)|(4G Box)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX)|(SecurDesktop)').test(device_type)"></div>

        <div class="flex flex-wrap" v-if="!new RegExp('(SRT334)|(SRT330)|(TWIG Beacon)|(^TELTONIKA)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX (?!Hub))|(SecurDesktop)').test(device_type)">
          <div class="w-full px-2 text-lg cursor-pointer" @click="isConfigVisible = !isConfigVisible">
            <div class="clear-both">
              <div class="float-left text-gray-600 font-bold pb-2 font-serif">{{ $t('alarm_create.additional_services') }}</div>
              <div class="float-right">
                <BaseIcon v-if="!isConfigVisible" class="" icon="chevron-down" />
                <BaseIcon v-if="isConfigVisible" class="" icon="chevron-up" />
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-wrap mt-3" v-if="isConfigVisible && !new RegExp('(SRT334)|(SRT330)|(TWIG Beacon)|(^TELTONIKA)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX (?!Hub))|(SecurDesktop)').test(device_type)">
          <div class="w-full md:w-1/2 px-2 mt-5" v-if="device_type !== 'securapp_eb10'">
            <div class="w-full flex flex-col">
              <div class="w-full text-gray-600 text-sm font-bold pb-2 font-serif">
                {{ getInternalDevicesAlertType() }} 
                <span v-if="new RegExp('^SRT').test(device_type)">(SRT)</span>
                <span v-if="new RegExp('^TWIG').test(device_type)">(TWIG)</span>
                <span v-if="new RegExp('^4G Box').test(device_type)">(4G Box)</span>
                <span v-if="new RegExp('^AJAX').test(device_type)">(AJAX)</span>
                <span v-if="isAppDevice">(App)</span>
                <span v-if="isEmeritOsmDevice">(Emerit)</span>
              </div>
              <div class="w-full">
                <treeselect ref="interdeviceTreeSelect" v-model="interdeviceAlertSelectNodes" :options="interdeviceAlerts"
                  :alwaysOpen="true" :appendToBody="false" :defaultExpandLevel="2" :disableBranchNodes="false" :showCount="true" showCountOf="LEAF_DESCENDANTS"
                  openDirection="below" :searchable="true" :maxHeight="500" :limit="2" :clearable="false"
                  :multiple="true" value-consists-of="LEAF_PRIORITY" valueFormat="object" noChildrenText="No Devices" class="treeselect-inline">
                  <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" :class="labelClassName" class="text-sm">
                    {{ node.label }}
                    <AppRecipientBadge :node="node" />
                    <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
                  </label>
                  <label slot="value-label" slot-scope="{ node }" class="text-sm">
                    {{ node.label }}
                    <AppRecipientBadge :node="node" chip />
                  </label>
                </treeselect>
                <!-- A copied device can bring phones along that this type
                     cannot reach; they stay listed, marked, until removed. -->
                <div class="text-xs text-red-700 mt-2 leading-snug" v-if="hasUndeliverableAppRecipients">{{ $t("alarm_info.app_recipients_not_delivered_note") }}</div>
              </div>
              
              <div class="w-full mt-4" v-if="new RegExp('(^TWIG)|(^SRT40)').test(device_type) || ((isAppDevice || isEmeritOsmDevice) && interdeviceAlertSelectNodes.length > 0)">
                <BaseTextarea rows="1" v-model="vibration_pushb_template" maxlength="130" :field_name="$t('alarm_create.on_screen_push_button')" rules="required" />
                <div class="">
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('vibration_pushb_template')">{{ $t('alarm_create.default') }}</button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('vibration_pushb_template', '<LarmNamn>')">{{ $t('alarm_create.alarm_name') }}</button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('vibration_pushb_template', '<RF-Tagg>')">{{ $t('alarm_create.rf_tag') }}<BaseIcon icon="wifi" class="ml-1" /></button>
                  <button class="btn-red-outline text-xxs mt-1" @click.prevent="vibration_pushb_template = ''">{{ $t('alarm_create.clear') }}<BaseIcon icon="backspace" class="ml-1" /></button>
                </div>
                <div class="mt-2 text-xs text-gray-600" v-if="new RegExp('^SRT40').test(device_type) || isAppDevice || isEmeritOsmDevice">
                  <label class="inline-flex items-center mr-3">
                    <input type="checkbox" v-model="osm_settings.pushb.text" class="form-checkbox h-4 w-4 text-blue-600">
                    <span class="ml-1">Display Text</span>
                  </label>
                  <label class="inline-flex items-center mr-3">
                    <input type="checkbox" v-model="osm_settings.pushb.blink" class="form-checkbox h-4 w-4 text-blue-600">
                    <span class="ml-1">LED Blink</span>
                  </label>
                  <label class="inline-flex items-center mr-3">
                    <input type="checkbox" v-model="osm_settings.pushb.vibration" class="form-checkbox h-4 w-4 text-blue-600">
                    <span class="ml-1">Vibration</span>
                  </label>
                  <label class="inline-flex items-center">
                    <input type="checkbox" v-model="osm_settings.pushb.sound" class="form-checkbox h-4 w-4 text-blue-600">
                    <span class="ml-1">Sound</span>
                  </label>
                </div>
              </div>
              <div class="w-full mt-4" v-if="new RegExp('^TWIG|(^SRT40)').test(device_type) || ((isAppDevice || isEmeritOsmDevice) && interdeviceAlertSelectNodes.length > 0)">
                <BaseTextarea rows="1" v-model="vibration_mandown_template" maxlength="130" :field_name="$t('alarm_create.on_screen_man_down')" rules="required" />
                <div class="">
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('vibration_mandown_template')">{{ $t('alarm_create.default') }}</button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('vibration_mandown_template', '<LarmNamn>')">{{ $t('alarm_create.alarm_name') }}</button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('vibration_mandown_template', '<RF-Tagg>')">{{ $t('alarm_create.rf_tag') }}<BaseIcon icon="wifi" class="ml-1" /></button>
                  <button class="btn-red-outline text-xxs mt-1" @click.prevent="vibration_mandown_template = ''">{{ $t('alarm_create.clear') }}<BaseIcon icon="backspace" class="ml-1" /></button>
                </div>
                <div class="mt-2 text-xs text-gray-600" v-if="new RegExp('^SRT40').test(device_type) || isAppDevice || isEmeritOsmDevice">
                  <label class="inline-flex items-center mr-3">
                    <input type="checkbox" v-model="osm_settings.mandown.text" class="form-checkbox h-4 w-4 text-blue-600">
                    <span class="ml-1">Display Text</span>
                  </label>
                  <label class="inline-flex items-center mr-3">
                    <input type="checkbox" v-model="osm_settings.mandown.blink" class="form-checkbox h-4 w-4 text-blue-600">
                    <span class="ml-1">LED Blink</span>
                  </label>
                  <label class="inline-flex items-center mr-3">
                    <input type="checkbox" v-model="osm_settings.mandown.vibration" class="form-checkbox h-4 w-4 text-blue-600">
                    <span class="ml-1">Vibration</span>
                  </label>
                  <label class="inline-flex items-center">
                    <input type="checkbox" v-model="osm_settings.mandown.sound" class="form-checkbox h-4 w-4 text-blue-600">
                    <span class="ml-1">Sound</span>
                  </label>
                </div>
              </div>
              <div class="w-full mt-4" v-if="new RegExp('^TWIG|(^SRT40)').test(device_type)">
                <BaseTextarea rows="1" v-model="vibration_callb_template" maxlength="130" :field_name="$t('alarm_create.on_screen_call_button')" rules="required" />
                <div class="">
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('vibration_callb_template')">{{ $t('alarm_create.default') }}</button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('vibration_callb_template', '<LarmNamn>')">{{ $t('alarm_create.alarm_name') }}</button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('vibration_callb_template', '<RF-Tagg>')">{{ $t('alarm_create.rf_tag') }}<BaseIcon icon="wifi" class="ml-1" /></button>
                  <button class="btn-red-outline text-xxs mt-1" @click.prevent="vibration_callb_template = ''">{{ $t('alarm_create.clear') }}<BaseIcon icon="backspace" class="ml-1" /></button>
                </div>
                <div class="mt-2 text-xs text-gray-600" v-if="new RegExp('^SRT40').test(device_type) || isAppDevice">
                  <label class="inline-flex items-center mr-3">
                    <input type="checkbox" v-model="osm_settings.callb.text" class="form-checkbox h-4 w-4 text-blue-600">
                    <span class="ml-1">Display Text</span>
                  </label>
                  <label class="inline-flex items-center mr-3">
                    <input type="checkbox" v-model="osm_settings.callb.blink" class="form-checkbox h-4 w-4 text-blue-600">
                    <span class="ml-1">LED Blink</span>
                  </label>
                  <label class="inline-flex items-center mr-3">
                    <input type="checkbox" v-model="osm_settings.callb.vibration" class="form-checkbox h-4 w-4 text-blue-600">
                    <span class="ml-1">Vibration</span>
                  </label>
                  <label class="inline-flex items-center">
                    <input type="checkbox" v-model="osm_settings.callb.sound" class="form-checkbox h-4 w-4 text-blue-600">
                    <span class="ml-1">Sound</span>
                  </label>
                </div>
              </div>
              <div class="w-full mt-4" v-if="new RegExp('(^SRT40)').test(device_type)">
                <BaseTextarea rows="1" v-model="vibration_callb2_template" maxlength="130" :field_name="$t('alarm_create.on_screen_call_button_2')" rules="required" />
                <div class="">
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('vibration_callb2_template')">{{ $t('alarm_create.default') }}</button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('vibration_callb2_template', '<LarmNamn>')">{{ $t('alarm_create.alarm_name') }}</button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('vibration_callb2_template', '<RF-Tagg>')">{{ $t('alarm_create.rf_tag') }}<BaseIcon icon="wifi" class="ml-1" /></button>
                  <button class="btn-red-outline text-xxs mt-1" @click.prevent="vibration_callb2_template = ''">{{ $t('alarm_create.clear') }}<BaseIcon icon="backspace" class="ml-1" /></button>
                </div>
                <div class="mt-2 text-xs text-gray-600">
                  <label class="inline-flex items-center mr-3">
                    <input type="checkbox" v-model="osm_settings.callb2.text" class="form-checkbox h-4 w-4 text-blue-600">
                    <span class="ml-1">Display Text</span>
                  </label>
                  <label class="inline-flex items-center mr-3">
                    <input type="checkbox" v-model="osm_settings.callb2.blink" class="form-checkbox h-4 w-4 text-blue-600">
                    <span class="ml-1">LED Blink</span>
                  </label>
                  <label class="inline-flex items-center mr-3">
                    <input type="checkbox" v-model="osm_settings.callb2.vibration" class="form-checkbox h-4 w-4 text-blue-600">
                    <span class="ml-1">Vibration</span>
                  </label>
                  <label class="inline-flex items-center">
                    <input type="checkbox" v-model="osm_settings.callb2.sound" class="form-checkbox h-4 w-4 text-blue-600">
                    <span class="ml-1">Sound</span>
                  </label>
                </div>
              </div>
              <div class="w-full mt-4" v-if="isAppDevice && interdeviceAlertSelectNodes.length > 0">
                <BaseTextarea rows="1" v-model="vibration_timer_alarm_template" maxlength="130" field_name="On-Screen Message Timer Alarm" rules="required" />
                <div class="">
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('vibration_timer_alarm_template')">{{ $t('alarm_create.default') }}</button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('vibration_timer_alarm_template', '<LarmNamn>')">{{ $t('alarm_create.alarm_name') }}</button>
                  <button class="btn-red-outline text-xxs mt-1" @click.prevent="vibration_timer_alarm_template = ''">{{ $t('alarm_create.clear') }}<BaseIcon icon="backspace" class="ml-1" /></button>
                </div>
                <div class="mt-2 text-xs text-gray-600" v-if="new RegExp('^SRT40').test(device_type) || isAppDevice">
                  <label class="inline-flex items-center mr-3">
                    <input type="checkbox" v-model="osm_settings.timer_alarm.text" class="form-checkbox h-4 w-4 text-blue-600">
                    <span class="ml-1">Display Text</span>
                  </label>
                  <label class="inline-flex items-center mr-3">
                    <input type="checkbox" v-model="osm_settings.timer_alarm.blink" class="form-checkbox h-4 w-4 text-blue-600">
                    <span class="ml-1">LED Blink</span>
                  </label>
                  <label class="inline-flex items-center mr-3">
                    <input type="checkbox" v-model="osm_settings.timer_alarm.vibration" class="form-checkbox h-4 w-4 text-blue-600">
                    <span class="ml-1">Vibration</span>
                  </label>
                  <label class="inline-flex items-center">
                    <input type="checkbox" v-model="osm_settings.timer_alarm.sound" class="form-checkbox h-4 w-4 text-blue-600">
                    <span class="ml-1">Sound</span>
                  </label>
                </div>
              </div>
              <div class="w-full mt-4" v-if="new RegExp('^AJAX Hub').test(device_type) && interdeviceAlertSelectNodes.length > 0">
                <div class="w-full text-gray-600 text-sm font-bold pb-2 font-serif">AJAX Hub Alert Settings</div>
                <div class="mt-2 text-xs text-gray-600">
                  <label class="inline-flex items-center mr-3">
                    <input type="checkbox" v-model="osm_settings.ajax_critical.text" class="form-checkbox h-4 w-4 text-blue-600">
                    <span class="ml-1">Display Text</span>
                  </label>
                  <label class="inline-flex items-center mr-3">
                    <input type="checkbox" v-model="osm_settings.ajax_critical.blink" class="form-checkbox h-4 w-4 text-blue-600">
                    <span class="ml-1">LED Blink</span>
                  </label>
                  <label class="inline-flex items-center mr-3">
                    <input type="checkbox" v-model="osm_settings.ajax_critical.vibration" class="form-checkbox h-4 w-4 text-blue-600">
                    <span class="ml-1">Vibration</span>
                  </label>
                  <label class="inline-flex items-center">
                    <input type="checkbox" v-model="osm_settings.ajax_critical.sound" class="form-checkbox h-4 w-4 text-blue-600">
                    <span class="ml-1">Sound</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="w-full md:w-1/3 px-2">
            <BaseSelect v-model="sms_alert" :options="sms_alerts" :field_name="$t('alarm_create.sms')" nameSelector="name" optionSelector="id" />
            <div class="w-full mt-3 flex flex-col" v-if="sms_alert != ''">
              <div class="w-full text-gray-600 text-sm font-bold pb-2 font-serif">{{ $t('alarm_create.number') }} <b class="text-xs italic font-normal font-sans text-secondary-500">({{ $t('alarm_create.phone_number_full') }})</b></div>
              <div class="w-full flex flex-wrap mt-2" v-for="(n, i) in sms_alert_phone" :key="i">
                <div class="w-11/12">
                  <ValidationProvider :name="$t('alarm_create.sms') + ' ' + $t('alarm_create.number') + ' ' + (i + 1)" rules="required|sms_msisdn|max:15" v-slot="{ classes, errors }">
                    <div class="input-validate" :class="classes">
                      <input v-model="n.msisdn" type="text" @keypress="isNumber($event)" maxlength="15" class="w-full bg-gray-100 rounded text-sm text-gray-900 focus:outline-none border-b-2 border-gray-300 transition duration-500 px-3 py-2" />
                      <span>{{ errors[0] }}</span>
                    </div>
                  </ValidationProvider>
                </div>
                <button class="w-1/12 text-red-500 pl-2" @click.prevent="removeSMSInput(i)"><BaseIcon icon="minus-circle" /></button>
              </div>
              <div class="w-full">
                <button class="btn-blue-outline mt-2" @click.prevent="addSMSInput()">{{ $t('alarm_create.add') }} <BaseIcon icon="plus" class="ml-1" /></button>
              </div>
              <div class="w-full mt-4" v-if="sms_alert == 'sms_pushb' || sms_alert == 'sms_both'">
                <BaseTextarea rows="2" v-model="sms_pushb_template" maxlength="160" :field_name="$t('alarm_create.sms_push_button')" rules="required" />
                <div class="">
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('sms_pushb_template')">{{ $t('alarm_create.default') }}</button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_pushb_template', '<LarmNamn>')">{{ $t('alarm_create.alarm_name') }}</button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_pushb_template', '<RF-Tagg>')">{{ $t('alarm_create.rf_tag') }}<BaseIcon icon="wifi" class="ml-1" /></button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_pushb_template', '<SecurCloud>')">{{ $t('alarm_create.securcloud') }}<BaseIcon icon="map-marker-alt" class="ml-1" /></button>
                  <button class="btn-red-outline text-xxs mt-1" @click.prevent="sms_pushb_template = ''">{{ $t('alarm_create.clear') }}<BaseIcon icon="backspace" class="ml-1" /></button>
                </div>
              </div>
              <div class="w-full mt-4" v-if="sms_alert == 'sms_mandown' || sms_alert == 'sms_both'">
                <BaseTextarea rows="2" v-model="sms_mandown_template" maxlength="160" :field_name="$t('alarm_create.sms_man_down')" rules="required" />
                <div class="">
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('sms_mandown_template')">{{ $t('alarm_create.default') }}</button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_mandown_template', '<LarmNamn>')">{{ $t('alarm_create.alarm_name') }}</button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_mandown_template', '<RF-Tagg>')">{{ $t('alarm_create.rf_tag') }}<BaseIcon icon="wifi" class="ml-1" /></button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_mandown_template', '<SecurCloud>')">{{ $t('alarm_create.securcloud') }}<BaseIcon icon="map-marker-alt" class="ml-1" /></button>
                  <button class="btn-red-outline text-xxs mt-1" @click.prevent="sms_mandown_template = ''">{{ $t('alarm_create.clear') }}<BaseIcon icon="backspace" class="ml-1" /></button>
                </div>
              </div>
              <div class="w-full mt-4" v-if="sms_alert == 'sms_callb' || sms_alert == 'sms_both'">
                <BaseTextarea rows="2" v-model="sms_callb_template" maxlength="160" :field_name="$t('alarm_create.sms_call_button')" rules="required" />
                <div class="">
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('sms_callb_template')">{{ $t('alarm_create.default') }}</button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_callb_template', '<LarmNamn>')">{{ $t('alarm_create.alarm_name') }}</button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_callb_template', '<RF-Tagg>')">{{ $t('alarm_create.rf_tag') }}<BaseIcon icon="wifi" class="ml-1" /></button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_callb_template', '<SecurCloud>')">{{ $t('alarm_create.securcloud') }}<BaseIcon icon="map-marker-alt" class="ml-1" /></button>
                  <button class="btn-red-outline text-xxs mt-1" @click.prevent="sms_callb_template = ''">{{ $t('alarm_create.clear') }}<BaseIcon icon="backspace" class="ml-1" /></button>
                </div>
              </div>
                             <div class="w-full mt-4" v-if="sms_alert == 'sms_callb2' || sms_alert == 'sms_both'">
                  <BaseTextarea rows="2" v-model="sms_callb2_template" maxlength="160" :field_name="$t('alarm_create.sms_call_button_2')" rules="required" />
                  <div class="">
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('sms_callb2_template')">{{ $t('alarm_create.default') }}</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_callb2_template', '<LarmNamn>')">{{ $t('alarm_create.alarm_name') }}</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_callb2_template', '<RF-Tagg>')">{{ $t('alarm_create.rf_tag') }}<BaseIcon icon="wifi" class="ml-1" /></button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_callb2_template', '<SecurCloud>')">{{ $t('alarm_create.securcloud') }}<BaseIcon icon="map-marker-alt" class="ml-1" /></button>
                    <button class="btn-red-outline text-xxs mt-1" @click.prevent="sms_callb2_template = ''">{{ $t('alarm_create.clear') }}<BaseIcon icon="backspace" class="ml-1" /></button>
                  </div>
                </div>
                <!-- Five push button -->
                <div class="w-full mt-4" v-if="sms_alert == 'sms_five_push' || sms_alert == 'sms_both'">
                  <BaseTextarea rows="2" v-model="sms_five_push_template" maxlength="160" :field_name="$t('alarm_create.sms_five_push')" rules="required" />
                  <div class="">
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('sms_five_push_template')">{{ $t('alarm_create.default') }}</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_five_push_template', '<LarmNamn>')">{{ $t('alarm_create.alarm_name') }}</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_five_push_template', '<RF-Tagg>')">{{ $t('alarm_create.rf_tag') }}<BaseIcon icon="wifi" class="ml-1" /></button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_five_push_template', '<SecurCloud>')">{{ $t('alarm_create.securcloud') }}<BaseIcon icon="map-marker-alt" class="ml-1" /></button>
                    <button class="btn-red-outline text-xxs mt-1" @click.prevent="sms_five_push_template = ''">{{ $t('alarm_create.clear') }}<BaseIcon icon="backspace" class="ml-1" /></button>
                  </div>
                </div>
                <!-- Timer alarm -->
                <div class="w-full mt-4" v-if="sms_alert == 'sms_timer_alarm' || sms_alert == 'sms_both'">
                  <BaseTextarea rows="2" v-model="sms_timer_alarm_template" maxlength="160" :field_name="$t('alarm_create.sms_timer_alarm')" rules="required" />
                  <div class="">
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('sms_timer_alarm_template')">{{ $t('alarm_create.default') }}</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_timer_alarm_template', '<LarmNamn>')">{{ $t('alarm_create.alarm_name') }}</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_timer_alarm_template', '<RF-Tagg>')">{{ $t('alarm_create.rf_tag') }}<BaseIcon icon="wifi" class="ml-1" /></button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_timer_alarm_template', '<SecurCloud>')">{{ $t('alarm_create.securcloud') }}<BaseIcon icon="map-marker-alt" class="ml-1" /></button>
                    <button class="btn-red-outline text-xxs mt-1" @click.prevent="sms_timer_alarm_template = ''">{{ $t('alarm_create.clear') }}<BaseIcon icon="backspace" class="ml-1" /></button>
                  </div>
                </div>
            </div>
          </div>

          <div v-if="!/(4G Box)|(AJAX (?!Hub))/.test(device_type)" class="w-full md:w-1/3 px-2 pt-3">
            <BaseSelect v-model="display_alert" :options="display_alerts" :field_name="$t('alarm_create.display_srt')" nameSelector="name" optionSelector="id" />
            <div class="w-full mt-3 flex flex-col" v-if="display_alert != ''">
              <div class="w-full text-gray-600 text-sm font-bold pb-2 font-serif">{{ $t('alarm_create.number') }} <b class="text-xs italic font-normal font-sans text-secondary-500">({{ $t('alarm_create.phone_number_full') }})</b></div>
              <div class="w-full flex flex-wrap mt-2" v-for="(n, i) in display_alert_phone" :key="i">
                <div class="w-11/12">
                  <ValidationProvider :name="'Display ' + $t('alarm_create.number') + ' ' + (i + 1)" rules="required|sms_msisdn|max:15" v-slot="{ classes, errors }">
                    <div class="input-validate" :class="classes">
                      <input v-model="n.msisdn" type="text" @keypress="isNumber($event)" maxlength="15" class="w-full bg-gray-100 rounded text-sm text-gray-900 focus:outline-none border-b-2 border-gray-300 transition duration-500 px-3 py-2" />
                      <span>{{ errors[0] }}</span>
                    </div>
                  </ValidationProvider>
                </div>
                <button class="w-1/12 text-red-500 pl-2" @click.prevent="removeDisplayInput(i)"><BaseIcon icon="minus-circle" /></button>
              </div>
              <div class="w-full">
                <button class="btn-blue-outline mt-2" @click.prevent="addDisplayInput()">{{ $t('alarm_create.add') }} <BaseIcon icon="plus" class="ml-1" /></button>
              </div>
              <div class="w-full mt-4" v-if="display_alert == 'display_pushb' || display_alert == 'display_both'">
                <BaseTextarea rows="2" v-model="display_pushb_template" maxlength="160" :field_name="$t('alarm_create.display_push_button')" rules="required" />
                <div class="">
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('display_pushb_template')">{{ $t('alarm_create.default') }}</button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('display_pushb_template', '<LarmNamn>')">{{ $t('alarm_create.alarm_name') }}</button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('display_pushb_template', '<RF-Tagg>')">{{ $t('alarm_create.rf_tag') }}<BaseIcon icon="wifi" class="ml-1" /></button>
                  <button class="btn-red-outline text-xxs mt-1" @click.prevent="display_pushb_template = ''">{{ $t('alarm_create.clear') }}<BaseIcon icon="backspace" class="ml-1" /></button>
                </div>
              </div>
              <div class="w-full mt-4" v-if="display_alert == 'display_mandown' || display_alert == 'display_both'">
                <BaseTextarea rows="2" v-model="display_mandown_template" maxlength="160" :field_name="$t('alarm_create.display_man_down')" rules="required" />
                <div class="">
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('display_mandown_template')">{{ $t('alarm_create.default') }}</button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('display_mandown_template', '<LarmNamn>')">{{ $t('alarm_create.alarm_name') }}</button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('display_mandown_template', '<RF-Tagg>')">{{ $t('alarm_create.rf_tag') }}<BaseIcon icon="wifi" class="ml-1" /></button>
                  <button class="btn-red-outline text-xxs mt-1" @click.prevent="display_mandown_template = ''">{{ $t('alarm_create.clear') }}<BaseIcon icon="backspace" class="ml-1" /></button>
                </div>
              </div>
              <div class="w-full mt-4" v-if="display_alert == 'display_callb' || display_alert == 'display_both'">
                <BaseTextarea rows="2" v-model="display_callb_template" maxlength="160" :field_name="$t('alarm_create.display_call_button')" rules="required" />
                <div class="">
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('display_callb_template')">{{ $t('alarm_create.default') }}</button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('display_callb_template', '<LarmNamn>')">{{ $t('alarm_create.alarm_name') }}</button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('display_callb_template', '<RF-Tagg>')">{{ $t('alarm_create.rf_tag') }}<BaseIcon icon="wifi" class="ml-1" /></button>
                  <button class="btn-red-outline text-xxs mt-1" @click.prevent="display_callb_template = ''">{{ $t('alarm_create.clear') }}<BaseIcon icon="backspace" class="ml-1" /></button>
                </div>
              </div>
              <div class="w-full mt-4" v-if="display_alert == 'display_callb2' || display_alert == 'display_both'">
                <BaseTextarea rows="2" v-model="display_callb2_template" maxlength="160" :field_name="$t('alarm_create.display_call_button_2')" rules="required" />
                <div class="">
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('display_callb2_template')">{{ $t('alarm_create.default') }}</button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('display_callb2_template', '<LarmNamn>')">{{ $t('alarm_create.alarm_name') }}</button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('display_callb2_template', '<RF-Tagg>')">{{ $t('alarm_create.rf_tag') }}<BaseIcon icon="wifi" class="ml-1" /></button>
                  <button class="btn-red-outline text-xxs mt-1" @click.prevent="display_callb2_template = ''">{{ $t('alarm_create.clear') }}<BaseIcon icon="backspace" class="ml-1" /></button>
                </div>
              </div>
              <div class="w-full mt-4" v-if="display_alert == 'display_timer' || display_alert == 'display_both'">
                <BaseTextarea rows="2" v-model="display_timer_template" maxlength="160" :field_name="$t('alarm_create.display_timer_alarm')" rules="required" />
                <div class="">
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('display_timer_template')">{{ $t('alarm_create.default') }}</button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('display_timer_template', '<LarmNamn>')">{{ $t('alarm_create.alarm_name') }}</button>
                  <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('display_timer_template', '<RF-Tagg>')">{{ $t('alarm_create.rf_tag') }}<BaseIcon icon="wifi" class="ml-1" /></button>
                  <button class="btn-red-outline text-xxs mt-1" @click.prevent="display_timer_template = ''">{{ $t('alarm_create.clear') }}<BaseIcon icon="backspace" class="ml-1" /></button>
                </div>
              </div>
            </div>
          </div>

          <div class="w-full px-4 py-4 mt-5 bg-gray-50" v-if="!/(4G Box)|(AJAX Hub)/.test(device_type)">
            <label class="inline-flex items-center mt-3">
              <input v-model="send_to_alarm_center" type="checkbox" class="form-checkbox h-4 w-4" />
                <span class="ml-2 text-gray-600 text-sm font-serif font-bold">
                  {{ $t('alarm_create.send_to_alarm_center') }} 
                </span> 
              </label>
            <template v-if="send_to_alarm_center">
              <div class="w-full" v-for="r in reportTypes" :key="r.id">
                <label class="inline-flex items-center mt-3">
                  <input v-model="tunnel_settings" :value="r.id" type="checkbox" class="form-checkbox h-3 w-3" /><span class="ml-2 text-sm font-sans font-semibold">{{ r.name }}</span>
                </label>{{tunnel_settings}}
              </div>
            </template>
          </div>
        </div>

        <div class="mx-2 border-b border-secondary-400 my-5" v-if="!new RegExp('(SRT334)|(SRT330)|(TWIG Beacon)|(^TELTONIKA)|(4G Box)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX (?!Hub))|(SecurDesktop)').test(device_type)"></div>

        <div class="flex flex-wrap mt-4" v-if="!new RegExp('(SRT334)|(SRT330)|(TWIG Beacon)|(^TELTONIKA)|(4G Box)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX)|(SecurDesktop)').test(device_type)">
          <!-- Safe-4 (SEC-364 A1): the operator instructions sit in a collapsed
               section, exactly as in the alarm action report. Shown from the start:
               on a new device no risk profile is picked yet, and hiding the whole
               section until then made it look missing. Other alarm centrals keep
               them open, exactly as before. -->
          <div class="w-full px-2" v-if="isSafe4Selected">
            <div class="flex items-center cursor-pointer text-sm font-semibold py-2" @click="show_operator_instructions = !show_operator_instructions">
              <span class="mr-2">{{ $t("change_alarm_plan.operator_instructions") }}</span>
              <BaseIcon icon="angle-down" v-if="!show_operator_instructions" />
              <BaseIcon icon="angle-up" v-else />
            </div>
            <template v-if="show_operator_instructions">
              <!-- the alarm profile exactly as the alarm plan PDF prints it -->
              <AlarmProfilePreview v-if="risk_profile" :risk-profile="risk_profile" />
              <p v-else class="text-xs italic px-2">{{ $t("change_alarm_plan.operator_instructions_no_profile") }}</p>
            </template>
          </div>
          <!-- the alarm profile exactly as the alarm plan PDF prints it -->
          <AlarmProfilePreview v-else-if="risk_profile" :risk-profile="risk_profile" :unit="unit_info" :customer="customer" />
        </div>

        <div class="w-full px-2 mt-2 mb-10">
          <div class="clearfix">
            <button class="btn-blue float-right px-3 py-2" type="submit" @click.prevent="createAlarm()">
              {{ $t('alarm_create.save') }}
              <BaseIcon icon="arrow-right" class="ml-2" />
            </button>
            <!-- Safe-4 devices get no alarm-centre email — the KUIS sync IS the notification (req 3) -->
            <button v-if="alarm_central && alarm_central !== '-' && !isSafe4Selected" class="btn-green float-right px-3 py-2 mr-2" type="button" @click.prevent="createAlarm(true)">
              {{ $t('alarm_create.save_and_send') }}
              <BaseIcon icon="envelope" class="ml-2" />
            </button>
          </div>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import siteContext from "@/utils/siteContext";
import { DEVICE_TYPES } from "@/utils/deviceTypes";
import { deliveryCompanyForSeller, securdiaDeliveryCompany } from "@/utils/deliveryCompany";
import { RISK_PROFILE, ALARM_SORT, normalizeRiskProfile, normalizeAlarmSort } from "@/utils/alarmEnums";
import { STANDARD_MESSAGE_TEMPLATES } from "@/constants/alarmMessageTemplates";
import AlarmProfilePreview from "@/components/alarm_profile_preview.vue";
import AppRecipientBadge from "@/components/app_recipient_badge.vue";

// Safe-4 (SEC-364 A3): contact persons are reached around the clock, so the three
// time fields hold the whole day - stored the way KUIS has it, so SecurCloud
// mirrors SAFECON (Rasmus, Q6: "store it as KUIS have so it mirrors their system"). KUIS keeps
// 00:00:00-23:59:59 on every contact; this is the same window in the fields'
// own HH:MM-HH:MM format (SEC-320).
const SAFE4_CONTACT_TIME = "00:00-23:59";



export default {
  siteContext, // Make siteContext available to component
  title() {
    return this.$t('alarm_create.page_title');
  },
  components: {
    Treeselect,
    AlarmProfilePreview,
    AppRecipientBadge,
  },
  data() {
    return {
      customer_id: this.$route.params.customer_id,
      unit_id: this.$route.params.unit_id,
      copy_alarm_id: this.$route.params.alarmId,
      sim_operators: ["Telia", "Telia DCP", "Telenor", "Tele2", "Kundens Simkort"],
      interdeviceAlertsDefault: [
        { level: 'event', id: "all", label: "All (Default)", isDisabled: false, isDefaultExpanded: false, children: null, message: "<Event> <DeviceName> <RF-Tagg>" },
        { level: 'event', id: "push_button", label: "Push Button", isDisabled: false, isDefaultExpanded: false, children: null, message: "Skarpt <DeviceName> <RF-Tagg>" },
        { level: 'event', id: "call_b", label: "Call Button", isDisabled: false, isDefaultExpanded: false, children: null, message: "Internt <DeviceName> <RF-Tagg>" },
        { level: 'event', id: "call_b2", label: "Call Button 2", isDisabled: false, isDefaultExpanded: false, children: null, message: "Internt 2 <DeviceName> <RF-Tagg>" },
        { level: 'event', id: "man_down", label: "Man Down", isDisabled: false, isDefaultExpanded: false, children: null, message: "Man-Down <DeviceName> <RF-Tagg>" },
        { level: 'event', id: "4gbox", label: "4G Box", isDisabled: false, isDefaultExpanded: false, children: null, message: "" },
        { level: "event", id: "ajax_critical", label: "AJAX SOS", isDisabled: false, isDefaultExpanded: false, children: null, message: "" },
        { level: "event", id: "timer_alarm", label: "Timer alarm", isDisabled: false, isDefaultExpanded: false, children: null, message: "Timer Alarm <DeviceName> <RF-Tagg>" },
      ],
      interdeviceAlerts: [],
      interdeviceAlertSelectNodes: [],
      sms_alerts: [
        { id: "sms_pushb", name: "Push B" },
        { id: "sms_mandown", name: "Man Down" },
        { id: "sms_callb", name: "Call B" },
        { id: "sms_4gbox", name: "4G Box" },
        { id: "sms_ajax_critical", name: "AJAX SOS" },
        { id: "sms_both", name: "Alla" },
      ],
      display_alerts: [
        { id: "display_pushb", name: "Push B" },
        { id: "display_mandown", name: "Man Down" },
        { id: "display_callb", name: "Call B" },
        { id: "display_4gbox", name: "4G Box" },
        { id: "display_ajax_critical", name: "AJAX SOS" },
        { id: "display_both", name: "Alla" },
      ],
      reportTypes: [{ name: "Internlarm", id: "call_b" }],
      unitDevicesTree: [],
      customer: {},
      unit_info: {},
      alarm_centrals: [],
      sellers: [],
      unit_alarms: [],
      orders: [],
      orders_filtered: [],
      // form fields
      ava_flex: {
      tag_serial_number: "",
      webhook: "",
      camera_token: "",
      },
      device_type: "",
      imei_number: "",
      alarm_phone_number: "",
      serial_number: "",
      operator: "",
      alarm_central: "",
      alarm_central_name: "",
      alarm_number: "",
      imsi_number: "", // SEC-337
      interdevice_alerts: [],
      vibration_pushb_template: STANDARD_MESSAGE_TEMPLATES.vibration_pushb_template,
      vibration_mandown_template: STANDARD_MESSAGE_TEMPLATES.vibration_mandown_template,
      vibration_callb_template: STANDARD_MESSAGE_TEMPLATES.vibration_callb_template,
      vibration_callb2_template: STANDARD_MESSAGE_TEMPLATES.vibration_callb2_template,
      vibration_timer_alarm_template: STANDARD_MESSAGE_TEMPLATES.vibration_timer_alarm_template,
      osm_settings: {
        pushb: { blink: true, vibration: true, sound: true, text: true },
        mandown: { blink: true, vibration: true, sound: true, text: true },
        callb: { blink: true, vibration: true, sound: true, text: true },
        callb2: { blink: true, vibration: true, sound: true, text: true },
        ajax_critical: { blink: true, vibration: true, sound: true, text: true },
        timer_alarm: { blink: true, vibration: true, sound: true, text: true }
      },
      sms_alert: "",
      sms_alert_phone: [],
      sms_pushb_template: STANDARD_MESSAGE_TEMPLATES.sms_pushb_template,
      sms_mandown_template: STANDARD_MESSAGE_TEMPLATES.sms_mandown_template,
      sms_callb_template: STANDARD_MESSAGE_TEMPLATES.sms_callb_template,
      sms_callb2_template: STANDARD_MESSAGE_TEMPLATES.sms_callb2_template,
      sms_five_push_template: STANDARD_MESSAGE_TEMPLATES.sms_five_push_template,
      sms_timer_alarm_template: STANDARD_MESSAGE_TEMPLATES.sms_timer_alarm_template,
      display_alert: "",
      display_alert_phone: [],
      display_pushb_template: STANDARD_MESSAGE_TEMPLATES.display_pushb_template,
      display_mandown_template: STANDARD_MESSAGE_TEMPLATES.display_mandown_template,
      display_callb_template: STANDARD_MESSAGE_TEMPLATES.display_callb_template,
      display_callb2_template: STANDARD_MESSAGE_TEMPLATES.display_callb2_template,
      display_timer_template: STANDARD_MESSAGE_TEMPLATES.display_timer_template,
      man_down: false,
      cash_agreement: false,
      agreement_number: "",
      agreement_length: "",
      seller: "",
      contract_party: "", // SEC-321: Avtalspart (contract party)
      selected_alarm_sort: "",
      personal_alarm: {
        reporting: "",
        // no risk_profile here: the Riskprofil dropdown above is the only one
        name: "",
        home_address: "",
        work_address: "",
        transport: "",
        registration_number: "",
        model: "",
        color: "",
      },
      risk_profile: "",
      show_operator_instructions: false, // SEC-364 A1: collapsed until the header is clicked
      reference_number: "",
      user: "1",
      alarm_name: "",
      from_address: {
        street: "",
        zip: "",
        city: "",
      },
      // Safe-4: the AlarmCenter _id that is Safe-4 (empty = integration off)
      safe4_center_id: "",
      alarm_unit_name: "",
      business_description: "",
      alarm_password: "",
      personal_password: "",
      external_contractor: {
        name: "",
        phone: "",
        object_id: "",
      },
      contact_persons: [
        { name: "", function: "", phone: "", weekday: "", saturday: "", sunday: "" },
        { name: "", function: "", phone: "", weekday: "", saturday: "", sunday: "" },
        { name: "", function: "", phone: "", weekday: "", saturday: "", sunday: "" },
      ],
      comment: "",
      gps_active: true,
      gps_log_active: true,
      send_to_alarm_center: false,
      tunnel_settings: [],
      order_id: "",
      inventory_number: "",
      direct_dispatch: false,
      device_status: '',
      // show/hide fields
      show_alarm_number: false,
      show_MSL_risk: false,
      show_personal_alarm: false,
      vibrationCheckAllAlarms: false,
      isConfigVisible: false,
      copy_alarm: null,
    };
  },

  computed: {
    /** App-paired device types — alarms arrive via the mobile app (SecurApp). */
    isAppDevice() {
      return /^SecurApp$/.test(this.device_type);
    },
    /** Emerit devices trigger an OSM on TWIG and SRT recipients (SEC-322) and
     * share the WG100/WG200 OSM config. This includes a standalone e-B10, which
     * reports to the Emerit TCP server like the WG units. Once paired with
     * SecurApp the type becomes 'securapp_eb10' and OSM config is hidden. */
    isEmeritOsmDevice() {
      return /^EMERIT/.test(this.device_type);
    },
    /** Does an internal alarm from this device type reach a phone? securecloud-server
     * pushes for the app raise, 4G Box and AJAX hub; securcloud-tcp-server for
     * TWIG, SRT and Emerit, SOS and man-down only. See alarm_info.vue. */
    sourceDeliversToApps() {
      return /^4G Box|^AJAX|^SRT|^TWIG/.test(this.device_type) || this.isAppDevice || this.isEmeritOsmDevice;
    },
    appsSosAndManDownOnly() {
      return /^SRT|^TWIG/.test(this.device_type) || this.isEmeritOsmDevice;
    },
    hasUndeliverableAppRecipients() {
      return (this.interdeviceAlertSelectNodes || []).some((node) => node && node.appUndeliverable);
    },
    /** True when the selected alarm central is Safe-4 (SEC-210). */
    isSafe4Selected() {
      return !!this.safe4_center_id && this.alarm_central == this.safe4_center_id;
    },
    // Safe-4 (SEC-370): a Norwegian site's postcode must be inside the county
    // ranges (utils/safe4Postcodes.js) - the server refuses the save otherwise.
    safe4PostcodeRules() {
      const country = (this.unit_info && this.unit_info.country) || (this.$options.siteContext.isNorwegianSite() ? "no" : "se");
      return `required|safe4_postcode:${country}`;
    },
    deviceStatuses() {
      return [
        { value: 'ny_bestallning', label: this.$t('device_status.ny_bestallning') },
        { value: 'utbytesenhet', label: this.$t('device_status.utbytesenhet') },
        { value: 'ersattningsprodukt', label: this.$t('device_status.ersattningsprodukt') },
      ];
    },
    alarmSortOptions() {
      return [
        { value: ALARM_SORT.GROUP, label: this.$t('alarm_create.group_alarm') },
        { value: ALARM_SORT.PERSONAL, label: this.$t('alarm_create.personal') },
      ];
    },
    transportOptions() {
      return [
        { value: 'walking', label: this.$t('alarm_create.transport_walking') },
        { value: 'bike', label: this.$t('alarm_create.transport_bike') },
        { value: 'public_transport', label: this.$t('alarm_create.transport_public_transport') },
        { value: 'car', label: this.$t('alarm_create.transport_car') },
      ];
    },
    riskProfileOptions() {
      return [
        { value: RISK_PROFILE.THREAT, label: this.$t('alarm_create.threat_alarm') },
        { value: RISK_PROFILE.EMERGENCY, label: this.$t('alarm_create.emergency_alarm') },
        { value: RISK_PROFILE.ASSAULT, label: this.$t('alarm_create.assault_alarm') },
      ];
    },
    riskProfileOptionsMSL() {
      // Malmö special-case options are intentionally kept as raw label values
      // (handled separately); only the standard profiles use stable codes.
      return [
        ...this.riskProfileOptions,
        { value: this.$t('alarm_create.malmo_fixed'), label: this.$t('alarm_create.malmo_fixed') },
        { value: this.$t('alarm_create.malmo_mobile'), label: this.$t('alarm_create.malmo_mobile') },
        { value: this.$t('alarm_create.malmo_emergency'), label: this.$t('alarm_create.malmo_emergency') },
      ];
    },
    devices() {
      // Single source of truth: @/utils/deviceTypes (SEC-216)
      return DEVICE_TYPES;
    },
    agreementNumberMask() {
      // Import and use the siteContext utility
      return this.$options.siteContext.getAgreementNumberMask();
    },
    isNorwegianSite() {
      return this.$options.siteContext.isNorwegianSite();
    },
    delivery_company() {
      // The chosen seller's company when it is a reseller, otherwise Securdia for this site
      const country = this.$options.siteContext.isNorwegianSite() ? "no" : "se";
      return deliveryCompanyForSeller(this.sellers, this.seller, country) || securdiaDeliveryCompany(country);
    },
    showDirectDispatch() {
      // Safe-4 (SEC-316): the toggle decides what Safe-4 registers for the
      // device — VEKTERRYKK (guard dispatch) or TELEFONVARSLING (phone only) —
      // so it is always available when the central is Safe-4.
      if (this.isSafe4Selected) return true;
      // Show direct dispatch option only for Norwegian site and if the selected alarm central has guard_dispatch enabled
      if (!this.$options.siteContext.isNorwegianSite()) return false;
      if (!this.alarm_central || this.alarm_central === '-') return false;
      const selectedAlarmCentral = _.find(this.alarm_centrals, { _id: this.alarm_central });
      return selectedAlarmCentral && selectedAlarmCentral.guard_dispatch === true;
    },
    isSosAlarm() {
      if (!this.alarm_central || this.alarm_central === '-') return false;
      const selectedAlarmCentral = _.find(this.alarm_centrals, { _id: this.alarm_central });
      return selectedAlarmCentral && /^SOS Alarm/i.test(selectedAlarmCentral.name);
    },
    // SEC-321: the "Avtalspart" field shows only for Westra + Commuter Security Group AB (CSG)
    isWestraSelected() {
      if (!this.alarm_central || this.alarm_central === '-') return false;
      const selectedAlarmCentral = _.find(this.alarm_centrals, { _id: this.alarm_central });
      return selectedAlarmCentral && /Westra/i.test(selectedAlarmCentral.name);
    },
    isCsgSeller() {
      const selectedSeller = _.find(this.sellers, { _id: this.seller });
      return selectedSeller && selectedSeller.name === 'Commuter Security Group AB (CSG)';
    },
    showContractParty() {
      return this.isWestraSelected && this.isCsgSeller;
    },
    // SEC-337: same rule as the edit form - the IMSI field belongs to one alarm
    // centre only, matched by its exact name so the separate "Securitas AB"
    // centre does not show it.
    showImsiNumber() {
      if (!this.alarm_central || this.alarm_central === '-') return false;
      const selectedAlarmCentral = _.find(this.alarm_centrals, { _id: this.alarm_central });
      return !!selectedAlarmCentral && selectedAlarmCentral.name === 'Securitas Sverige AB';
    },
    // SEC-321: proxy the dropdown so the None option has a real value ('none')
    // instead of '' (BaseSelect already renders a value="" placeholder, which
    // would otherwise shadow it). The stored contract_party stays "" for None.
    contractPartyChoice: {
      get() {
        return this.contract_party || 'none';
      },
      set(v) {
        this.contract_party = v === 'none' ? '' : v;
      },
    },
  },

  watch: {
    alarm_central() {
      // When alarm central is set/changed, check alarm center specifics
      this.check_alarm_center_specifics();
      this.check_contract_party(); // SEC-321
      // SEC-337: an IMSI typed for Securitas Sverige AB must not be saved on a
      // device that ends up on another centre
      if (!this.showImsiNumber) this.imsi_number = "";
    },
    // SEC-321: Avtalspart also depends on the seller
    seller() {
      this.check_contract_party();
    },
    // Safe-4 (SEC-364 A3/A5): picking Safe-4 fills the contact time fields with
    // the whole day and empties the personal password, whatever another alarm central left
    isSafe4Selected(isSafe4) {
      if (isSafe4) this.applySafe4FieldDefaults();
    },
    // SEC-373: contact persons copied from another alarm while Safe-4 already
    // is the central (so the watcher above does not fire) get the defaults too
    contact_persons() {
      if (this.isSafe4Selected) this.applySafe4FieldDefaults();
    },
  },

  methods: {
    /**
     * The Safe-4 defaults for a device being created (SEC-364).
     *
     * 1. Contact persons are called around the clock, so all three time fields
     *    hold the whole day - whatever another alarm central left there is replaced.
     * 2. KUIS has no personal password, so that field is emptied; the template
     *    hides it while Safe-4 is selected.
     */
    applySafe4FieldDefaults() {
      (this.contact_persons || []).forEach((contact) => {
        this.$set(contact, "weekday", SAFE4_CONTACT_TIME);
        this.$set(contact, "saturday", SAFE4_CONTACT_TIME);
        this.$set(contact, "sunday", SAFE4_CONTACT_TIME);
      });

      this.personal_password = "";

      // A16: a personal alarm cannot be sent to Safe-4, so it becomes a group alarm
      if (normalizeAlarmSort(this.selected_alarm_sort) === ALARM_SORT.PERSONAL) {
        this.selected_alarm_sort = ALARM_SORT.GROUP;
        this.show_personal_alarm = false;
      }
    },
    /**
     * Upper-case the fields KUIS keeps in upper case (SEC-364): the device
     * password, every contact person's name and function, and the street of
     * the "Starts from address". Run just before saving, so typing stays normal.
     */
    applySafe4UpperCase() {
      const upper = (value) => String(value == null ? "" : value).trim().toUpperCase();

      this.alarm_password = upper(this.alarm_password);

      (this.contact_persons || []).forEach((contact) => {
        this.$set(contact, "name", upper(contact.name));
        this.$set(contact, "function", upper(contact.function));
      });

      this.$set(this.from_address, "street", upper(this.from_address.street));
    },
    // SEC-330: put the standard text into one message field, replacing
    // whatever is in it. This is what the "Standard" button does now — it
    // used to add the text to the end of the field, so pressing it twice
    // gave the text twice.
    applyStandardTemplate(fieldName) {
      const standardText = STANDARD_MESSAGE_TEMPLATES[fieldName];
      if (standardText === undefined) return;

      this[fieldName] = standardText;
    },

    // SEC-361: what the Larmnamn / RF-Tagg / SecurCloud buttons do. The
    // placeholder goes at the end of the text, as before, but no longer glued
    // on: pressing Larmnamn and then SecurCloud used to give
    // "<LarmNamn><SecurCloud>", and the link in the SMS could not be opened.
    // One space is put in front, unless the text is empty or already ends with
    // a space or a line break.
    insertPlaceholder(fieldName, placeholder) {
      const text = this[fieldName] || "";
      const endsWithSpace = /\s$/.test(text);

      if (text === "" || endsWithSpace) {
        this[fieldName] = text + placeholder;
      } else {
        this[fieldName] = text + " " + placeholder;
      }
    },

    getCustomer() {
      this.axios
        .get(`${process.env.VUE_APP_SERVER_URL}/customer/${this.customer_id}`)
        .then(async (response) => {
          this.customer = response.data.customer;
          if (this.copy_alarm_id) this.fetchAlarm();
        })
        .catch((error) => {
          this.handleError(error);
        });
    },

    getUnit() {
      this.axios
        .get(`${process.env.VUE_APP_SERVER_URL}/units/${this.unit_id}`)
        .then((response) => {
          this.unit_info = response.data.data;
          this.$nextTick().then(() => {
            this.alarm_unit_name = this.unit_info.name;
            // this.from_address.city = `${this.unit_info.address} ${this.unit_info.zip_code} ${this.unit_info.city}`;
            this.alarm_central = this.unit_info.alarm_central;
            this.seller = this.unit_info.seller_id;
          });
        })
        .catch((error) => {
          this.handleError(error);
        });
    },

    getUnitAlarms() {
      this.axios
        .get(`${process.env.VUE_APP_SERVER_URL}/unit/alarms/${this.unit_id}`)
        .then((response) => {
          this.unit_alarms = response.data.unit_alarms;
        })
        .catch((error) => {
          this.handleError(error);
        });
    },

    async getAlarmCentrals() {
      this.axios
        .get(`${process.env.VUE_APP_SERVER_URL}/alarm-central`)
        .then((response) => {
          this.alarm_centrals = response.data.data;
          this.check_alarm_center_specifics();
        })
        .catch((error) => {
          this.handleError(error);
        });
    },

    getSellersResellers() {
      this.axios
        .get(`${process.env.VUE_APP_SERVER_URL}/seller/reseller`)
        .then((response) => {
          this.sellers = response.data.data;
        })
        .catch((error) => {
          this.handleError(error);
        });
    },

    getOrderDocument() {
      this.axios
        .get(`${process.env.VUE_APP_SERVER_URL}/orders`)
        .then((response) => {
          this.orders = response.data.orders;
          this.orders_filtered = this.orders;
        })
        .catch((error) => {
          this.handleError(error);
        });
    },

    getDevicesTree() {
      this.axios
        .get(`${process.env.VUE_APP_SERVER_URL}/list/customer/${this.customer_id}/devices`)
        .then((response) => {
          this.unitDevicesTree = response.data.devicesTree;
          this.populateInterDeviceAlertTree();
        })
        .catch((error) => {
          this.handleError(error);
        });
    },

    // SEC-321: default Avtalspart to CSG when it becomes visible (Westra + CSG seller),
    // and clear it whenever that combination is broken so a stale value is never sent.
    check_contract_party() {
      if (this.showContractParty) {
        if (!this.contract_party) this.contract_party = 'Commuter Security Group AB (CSG)';
      } else {
        this.contract_party = '';
      }
    },
    check_alarm_center_specifics() {
      let a = _.find(this.alarm_centrals, { _id: this.alarm_central });

      //Show alarm number field
      if (a && /(Stanley Security)|(Securitas AB)|(Rapid Larmcentral)|(Cubsec Larmcentral)|(Security Assistance Syd AB)|(Addici Security AB)|(Avarn HTTP Test)|(Avarn Security AS)|(NO - alarm central)/.test(a.name)) {
        this.show_alarm_number = true;
      }
      else {
        this.alarm_number = "";
        this.show_alarm_number = false;
      }
      // Show alarm center specific risk profiles
      if (a && /(Malmö Stads Larmcentral)|(Skyresponse Malmö)/.test(a.name)) this.show_MSL_risk = true;
    },

    regenerateAlarmNumberFromSerial() {
      // Generate alarm number from serial number: 8 + last 6 digits
      if (this.serial_number) {
        const last6Digits = this.serial_number.slice(-6);
        this.alarm_number = '8' + last6Digits;
      } else {
        this.handleError(null, this.$t('alarm_create.serial_number_required_for_alarm_number'));
      }
    },

    check_personal_alarm() {
      if (normalizeAlarmSort(this.selected_alarm_sort) === ALARM_SORT.PERSONAL) this.show_personal_alarm = true;
      else {
        (this.personal_alarm = {
          reporting: "",
          name: "",
        }),
          (this.show_personal_alarm = false);
      }
    },

    populateAlarmFields() {
      this.device_type = this.copy_alarm.type;
      this.operator = this.copy_alarm.operator;
      this.alarm_central = this.copy_alarm.alarm_central;
      // Don't copy alarm_number - it should be unique for each alarm
      // this.alarm_number = this.copy_alarm.alarm_number;
      this.interdevice_alerts = this.copy_alarm.interdevice_alerts;
      this.vibration_pushb_template = this.copy_alarm.vibration_pushb_template;
      this.vibration_mandown_template = this.copy_alarm.vibration_mandown_template;
      this.vibration_callb_template = this.copy_alarm.vibration_callb_template;
      this.sms_alert = this.copy_alarm.sms_alert;
      this.sms_alert_phone = this.copy_alarm.sms_alert_phone;
      this.sms_pushb_template = this.copy_alarm.sms_pushb_template.trim();
      this.sms_mandown_template = this.copy_alarm.sms_mandown_template.trim();
      this.sms_callb_template = this.copy_alarm.sms_callb_template.trim();
      this.sms_callb2_template = this.copy_alarm.sms_callb2_template.trim();
      this.sms_timer_alarm_template = this.copy_alarm.sms_timer_alarm_template.trim();
      this.sms_five_push_template = this.copy_alarm.sms_five_push_template.trim();
      this.display_alert = this.copy_alarm.display_alert;
      this.display_alert_phone = this.copy_alarm.display_alert_phone;
      this.display_pushb_template = this.copy_alarm.display_pushb_template.trim();
      this.display_mandown_template = this.copy_alarm.display_mandown_template.trim();
      this.display_callb_template = this.copy_alarm.display_callb_template.trim();
      this.display_callb2_template = this.copy_alarm.display_callb2_template.trim();
      this.display_timer_template = this.copy_alarm.display_timer_template.trim();
      this.man_down = this.copy_alarm.man_down;
      this.cash_agreement = this.copy_alarm.cash_agreement;
      this.agreement_number = this.copy_alarm.agreement_number;
      this.agreement_length = this.copy_alarm.agreement_length;
      this.seller = this.copy_alarm.seller;
      // delivery_company is now a computed property based on domain, no need to copy
      this.selected_alarm_sort = normalizeAlarmSort(this.copy_alarm.selected_alarm_sort);
      // copy of another device: take its personal-alarm answers, minus the old
      // risk profile - the Riskprofil dropdown above is the only one now
      this.personal_alarm = { ...this.copy_alarm.personal_alarm };
      delete this.personal_alarm.risk_profile;
      this.risk_profile = normalizeRiskProfile(this.copy_alarm.risk_profile);
      this.user = this.copy_alarm.user;
      this.from_address = this.copy_alarm.from_address;
      // this.alarm_unit_name = this.copy_alarm.alarm_unit_name;
      this.business_description = this.copy_alarm.business_description;
      this.alarm_password = this.copy_alarm.alarm_password;
      this.personal_password = this.copy_alarm.personal_password;
      this.external_contractor = this.copy_alarm.external_contractor;
      this.contact_persons = this.copy_alarm.contact_persons;
      this.gps_active = this.copy_alarm.gps_active;
      this.gps_log_active = this.copy_alarm.gps_log_active;
      this.send_to_alarm_center = this.copy_alarm.send_to_alarm_center;
      this.tunnel_settings = this.copy_alarm.tunnel_settings;
      this.inventory_number = this.copy_alarm.inventory_number;
      this.device_status = this.copy_alarm.device_status || '';
      // For camera integration
      this.ava_flex.tag_serial_number = this.copy_alarm.ava_flex.tag_serial_number;
      this.ava_flex.webhook = this.copy_alarm.ava_flex.webhook;
      this.ava_flex.camera_token = this.copy_alarm.ava_flex.camera_token;

      this.check_alarm_center_specifics();
      this.check_personal_alarm();
      this.populateInterDeviceAlertTree();
      this.filterOrders();

      this.$refs.formCreateAlarm.reset();
    },

    fetchAlarm() {
      this.axios
        .get(`${process.env.VUE_APP_SERVER_URL}/alarms/${this.copy_alarm_id}`)
        .then((response) => {
          this.copy_alarm = response.data.data;
          this.populateAlarmFields();
        })
        .catch((error) => {
          this.handleError(error);
        });
    },

    switchAgreement() {
      if (this.cash_agreement) {
        this.agreement_number = "Kontant";
        this.agreement_length = "-";
      } else {
        this.agreement_number = "";
        this.agreement_length = "";
      }
    },

    generateInterDeviceAlertSchema() {
      let events = [];

      for (let i = 0; i < this.interdeviceAlertSelectNodes.length; i++) {
        let node = this.interdeviceAlertSelectNodes[i];
        // build desired schema from selected objects
        if(node.level == 'event') {
          let devices = [];

          // process all event children
          for (let j = 0; j < node.children.length; j++) {
            let unit = node.children[j];
            
            // process all unit children
            for (let k = 0; k < unit.children.length; k++) {
              let device = unit.children[k];
              devices.push(device.imei_number);
            }
          }

          // check if event object already exists
          let e = _.findIndex(events, { id: node.id });

          if(e > -1) {
            let event = events[e];
            event.devices = [...event.devices, ...devices];
          }
          else {
            events.push({
              id: node.id,
              devices,
            });
          }
        }
        else if(node.level == 'unit') {
          let devices = [];

          // devices
          for (let j = 0; j < node.children.length; j++) {
            let device = node.children[j];
            devices.push(device.imei_number);
          }

          // check if event object already exists
          let e = _.findIndex(events, { id: node.event });

          if(e > -1) {
            let event = events[e];
            event.devices = [...event.devices, ...devices];
          }
          else {
            events.push({
              id: node.event,
              devices,
            });
          }
        }
        else if(node.level == 'device') {
          let e = _.findIndex(events, { id: node.event });

          if(e > -1) {
            let event = events[e];
            event.devices.push(node.imei_number);
          }
          else {
            events.push({
              id: node.event,
              devices: [node.imei_number],
            });
          }
        }
      }

      return events;
    },

    populateInterDeviceAlertTree() {
      // populate tree
      // generate selected node array
      let selectedNodes = [];
      let interdeviceAlerts = []

      // populate event based on device type
      for (let i = 0; i < this.interdeviceAlertsDefault.length; i++) {
        let event = this.interdeviceAlertsDefault[i];

        if (( (/(^SRT)|(^TWIG)/.test(this.device_type) && /(^4gbox)|(^ajax_critical)/.test(event.id)) ||
          (/(^TWIG)|(^SRT30)|(^SRT326$)|(^SRT278$)/.test(this.device_type) && event.id == "call_b2") ||
          (this.device_type == "4G Box" && event.id != "4gbox") ||
          (/(^AJAX)/.test(this.device_type) && event.id != "ajax_critical") ||
          (this.isAppDevice && !/^(all|push_button|man_down|timer_alarm)$/.test(event.id)) ||
          // Emerit units only ever report push_button and man_down (SEC-322)
          (this.isEmeritOsmDevice && !/^(all|push_button|man_down)$/.test(event.id)) )) continue;         
        else interdeviceAlerts.push(event);
      }
      this.interdeviceAlerts = interdeviceAlerts;

      // populate event childs
      for (let i = 0; i < this.interdeviceAlerts.length; i++) {
        let event = this.interdeviceAlerts[i];
        
        if (i == 0) event.isDefaultExpanded = true;
        else event.isDefaultExpanded = false;
        
        // uniq id to each node
        let unitDevicesTree = _.cloneDeep(this.unitDevicesTree);

        // What the copied device already sends this event to, so a phone the
        // picker no longer offers for this type stays listed and removable.
        let savedEvent = _.find(this.interdevice_alerts, { id: event.id });
        let savedImeis = savedEvent && Array.isArray(savedEvent.devices) ? savedEvent.devices : [];
        let appReachable = this.sourceDeliversToApps && (!this.appsSosAndManDownOnly || /^(all|push_button|man_down)$/.test(event.id));

        for (let j = 0; j < unitDevicesTree.length; j++) {
          let unit = unitDevicesTree[j];
          unit.event = event.id;
          // rename ids so they be unique across all events/units/devices
          unit.id = `${event.id}_${unit.id}`;

          if (i == 0 && j == 0) unit.isDefaultExpanded = true;
          else unit.isDefaultExpanded = false;

          let children = [];

          for (let k = 0; k < unit.children.length; k++) {
            let device = unit.children[k];
            device.event = event.id;
            device.id = `${event.id}_${unit.id}_${device.id}`;

            // A phone on a source/event that cannot reach it (appReachable):
            // kept and marked, never silently dropped from the copy.
            let isApp = /^SecurApp$/.test(device.type);
            device.appUndeliverable = isApp && !appReachable;

            if ( (/^SRT/.test(this.device_type) && /^SRT((?!(334)|(330)|(430)).)*$/.test(device.type) ) || 
              (/^TWIG/.test(this.device_type) && /^TWIG((?!(Beacon)|(Anchor Beacon)).)*$/.test(device.type) ) || 
              (/^4G Box/.test(this.device_type) && /(^TWIG((?!Beacon).)*$)/.test(device.type)) || 
              (/^AJAX/.test(this.device_type) && /((^TWIG((?!Beacon).)*$))|(^SRT((?!(334)|(330)|(430)|(326)|(306)|(278)|(341)).))/.test(device.type)) ||
              // Emerit reaches both families: TWIG over SMS, SRT over its own socket (SEC-322)
              (this.isEmeritOsmDevice && /(^TWIG((?!Beacon).)*$)|(^SRT((?!(334)|(330)|(430)).)*$)/.test(device.type)) ||
              // An app device as SOURCE. It had no branch at all, so a virtual
              // device's picker came back empty and the whole OSM section stayed
              // hidden behind interdeviceAlertSelectNodes.length > 0 — nothing in
              // this feature was configurable. It fans out through the same
              // chain as the rest, so it reaches both hardware families.
              (this.isAppDevice && /(^TWIG((?!Beacon).)*$)|(^SRT((?!(334)|(330)|(430)).)*$)/.test(device.type)) ||
              // The app as a RECIPIENT — a virtual device or a phone paired
              // with a device token, both 'SecurApp' rows reachable by push —
              // offered only where the fan-out has the app transport for this
              // event. Elsewhere a phone shows only when the copy already carries it.
              (isApp && (appReachable || savedImeis.indexOf(device.imei_number) > -1)) ) {
                // A paused virtual device stays listed and selectable, marked
                // "paused" in the label; the mobile API drops it from every push
                // while paused (see alarm_info.vue for why it is not disabled).
                // todo: 4gbox add srt40 series devices
                children.push(device);
                
                // populate selected nodes if device match
                let ei = _.findIndex(this.interdevice_alerts, { id: event.id }); 
                if(ei > -1) {
                  let ev = this.interdevice_alerts[ei];
                  if(ev && ev.devices.indexOf(device.imei_number) > -1) selectedNodes.push(device);
                }
            }
          }

          unit.children = children;
        }

        event.children = unitDevicesTree;
      }

      this.interdeviceAlertSelectNodes = selectedNodes;
    },

    getInternalDevicesAlertType() {
      if (/^SRT40/.test(this.device_type)) return "On-Screen Message";
      if (/^SRT/.test(this.device_type)) return "9-vibb";
      else if (/^TWIG/.test(this.device_type)) return "On-Screen Message";
      else if (/^4G Box/.test(this.device_type)) return "On-Screen Message";
      else if (/^AJAX/.test(this.device_type)) return "On-Screen Message";
      else if (this.isAppDevice) return "On-Screen Message";
      else if (this.isEmeritOsmDevice) return "On-Screen Message";
      else return "N/A";
    },

    addSMSInput() {
      this.sms_alert_phone.push({ msisdn: "" });
    },

    removeSMSInput(i) {
      this.sms_alert_phone.splice(i, 1);
    },

    addDisplayInput() {
      this.display_alert_phone.push({ msisdn: "" });
    },

    removeDisplayInput(i) {
      this.display_alert_phone.splice(i, 1);
    },

    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    filterOrders() {
      this.order_id = "";
      if (this.device_type != "") this.orders_filtered = _.filter(this.orders, { type: this.device_type });
      else this.orders_filtered = this.orders;

      // Reset alarm number state for devices that don't use alarm central (tags etc.)
      if (new RegExp('(SRT334)|(SRT330)|(TWIG Beacon)|(^TELTONIKA)|(4G Box)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX)|(SecurDesktop)').test(this.device_type)) {
        this.show_alarm_number = false;
        this.alarm_number = "";
      }

      this.populateInterDeviceAlertTree();
    },

    populateFieldFromOrder() {
      let order = _.find(this.orders, { _id: this.order_id });
      if (order) {
        this.device_type = order.type;
        this.serial_number = order.modelnumber;
        this.imei_number = order.imei_number;
      } else {
        this.serial_number = "";
        this.imei_number = "";
      }
    },

    async createAlarm(sendAfterCreate = false) {
      const success = await this.$refs.formCreateAlarm.validate();
      if (!success) return;

      // Safe-4 (SEC-364): KUIS keeps these fields in upper case, and the review
      // asks for them to be stored that way too
      if (this.isSafe4Selected) this.applySafe4UpperCase();

      // Validate alarm_number if it's required (show_alarm_number is true)
      if (this.show_alarm_number && !this.alarm_number) {
        this.handleError(null, this.$t('alarm_create.alarm_number_required'));
        return;
      }

      if (this.device_type == "SRT334" || this.device_type == "SRT330" || this.device_type == "TWIG Beacon" || this.device_type == "Anchor Beacon" || this.device_type == "Anchor Beacon" || this.device_type == "Avigilon Alta Compact Dome 5MP") {
        this.gps_active = false;
        this.gps_log_active = false;
      }

      let interdevice_alerts = this.generateInterDeviceAlertSchema();

      // use serial number for imei, incase imei is optional
      let imeiNumber = this.imei_number;
      if(/^AJAX/.test(this.device_type)) imeiNumber = this.serial_number;

      let data = {
          type: this.device_type,
          imei_number: imeiNumber,
          phone: this.alarm_phone_number,
          modelnumber: this.serial_number,
          operator: this.operator,
          alarm_central: this.alarm_central,
          alarm_number: this.alarm_number,
          imsi_number: this.showImsiNumber ? this.imsi_number : "", // SEC-337
          interdevice_alerts,
          vibration_pushb_template: this.vibration_pushb_template,
          vibration_mandown_template: this.vibration_mandown_template,
          vibration_timer_alarm_template: this.vibration_timer_alarm_template,
          vibration_callb_template: this.vibration_callb_template,
          vibration_callb2_template: this.vibration_callb2_template,
          osm_settings: this.osm_settings,
          sms_alert: this.sms_alert,
          sms_alert_phone: this.sms_alert_phone,
          sms_pushb_template: this.sms_pushb_template,
          sms_mandown_template: this.sms_mandown_template,
          sms_callb_template: this.sms_callb_template,
          sms_callb2_template: this.sms_callb2_template,
          sms_five_push_template: this.sms_five_push_template,
          sms_timer_alarm_template: this.sms_timer_alarm_template,
          display_alert: this.display_alert,
          display_alert_phone: this.display_alert_phone,
          display_pushb_template: this.display_pushb_template,
          display_mandown_template: this.display_mandown_template,
          display_callb_template: this.display_callb_template,
          display_callb2_template: this.display_callb2_template,
          display_timer_template: this.display_timer_template,
          man_down: this.man_down,
          direct_dispatch: this.direct_dispatch,
          cash_agreement: this.cash_agreement,
          agreement_number: this.agreement_number,
          agreement_length: this.agreement_length,
          seller: this.seller,
          contract_party: this.contract_party, // SEC-321
          delivery_company: this.delivery_company,
          selected_alarm_sort: this.selected_alarm_sort,
          personal_alarm: this.personal_alarm,
          risk_profile: this.risk_profile,
          reference_number: this.reference_number,
          user: this.user,
          unit_name: this.alarm_name,
          from_address: this.from_address,
          alarm_unit_name: this.alarm_unit_name,
          business_description: this.business_description,
          alarm_password: this.alarm_password,
          personal_password: this.personal_password,
          external_contractor: this.external_contractor,
          contact_persons: this.contact_persons,
          parent_id: this.unit_info.unit_id,
          comment: this.comment,
          gps_active: this.gps_active,
          gps_log_active: this.gps_log_active,
          send_to_alarm_center: this.send_to_alarm_center,
          tunnel_settings: this.tunnel_settings,
          order_id: this.order_id,
          ava_flex: {
            tag_serial_number: this.ava_flex.tag_serial_number,
            webhook: this.ava_flex.webhook,
            camera_token: this.ava_flex.camera_token,
          },
          inventory_number: this.inventory_number,
          device_status: this.device_status,

        };

      try {
        const response = await this.axios.post(`${process.env.VUE_APP_SERVER_URL}/alarms/`, data);

        // Safe-4 (req 6): the registration ran during the save. If it did NOT
        // sync, the user must acknowledge the error and stays on the form.
        const s4 = response.data && response.data.safe4;
        if (s4 && s4.attempted && !s4.ok) {
          const message = s4.buffered
            ? this.$t("safe4_form.sync_buffered")
            : this.$t("safe4_form.sync_failed", { code: s4.errorCode || s4.error || "?" });
          this.handleError(null, message);
          return;
        }
        if (s4 && s4.attempted && s4.ok) this.handleSuccess(s4.removed ? this.$t("safe4_form.removed") : this.$t("safe4_form.synced"));

        // only a device saved WITH an alarm central has one to send to
        if (sendAfterCreate && response.data.alarm_id && data.alarm_central && data.alarm_central !== "-") {
          try {
            await this.sendAlarmCenterPDF({ _id: response.data.alarm_id, ...data });
          } catch {
            // Error already shown by sendAlarmCenterPDF; alarm is saved, navigate anyway
          }
        }

        this.$router.push({ name: "alarms", params: { type: "customer", customer_id: this.customer_id, unit_id: this.unit_id, id: "-" } });
      } catch (error) {
        // duplicate IMEI / serial / phone / inventory number (SEC-216)
        // Safe-4 refused the data: nothing was saved (SEC-364 B1)
        if (!this.handleSafe4Rejection(error, this.$refs.formCreateAlarm) && !this.handleIdentifierConflict(error)) {
          this.handleError(error);
        }
      }
    },

    async sendAlarmCenterPDF(alarm) {
      try {
        let customerName = this.customer ? this.customer.name : "";

        let doc = await this.generateAlarmPlanPDF({
          alarm,
          customerName,
          sellers: this.sellers,
          oldAlarm: alarm,
          highlight: false,
          showAlarmNumber: this.show_alarm_number,
          showImsiNumber: this.showImsiNumber, // SEC-337
          showDirectDispatch: this.showDirectDispatch,
          unit: this.unit_info,
          customer: this.customer,
        });

        let base = doc.output("blob");
        let formData = new FormData();
        formData.append("pdf", base);
        formData.append("alarm_id", alarm._id);
        formData.append("is_new", "true");

        let headers = {
          "X-Access-Token": this.$store.state.token,
          "Content-Type": "multipart/form-data",
        };

        const response = await this.axios.post(
          `${process.env.VUE_APP_SERVER_URL}/alarm-center/${alarm.alarm_central}/email`,
          formData,
          headers
        );

        if (response.data.error) {
          this.handleError(null, this.$t("change_alarm_plan.email_send_error"));
        } else if (response.data.success) {
          this.handleSuccess(this.$t("change_alarm_plan.sent_to_alarm_center"));
        }
      } catch (error) {
        this.handleError(error, this.$t("change_alarm_plan.email_send_error"));
        throw error;
      }
    },
  },

  created() {
    // Safe-4: which alarm central is Safe-4 (fails quietly -> no Safe-4 behavior)
    this.axios
      .get(`${process.env.VUE_APP_SERVER_URL}/safe4/config`)
      .then((res) => { this.safe4_center_id = res.data.safe4_alarm_center_id || ""; })
      .catch(() => { this.safe4_center_id = ""; });
    this.getAlarmCentrals();
    this.getSellersResellers();
    this.getCustomer();
    this.getUnit();
    this.getOrderDocument();
    this.getUnitAlarms();
    this.getDevicesTree();

    this.setPageTitle(this.$t("top_titles.new_product"), "create_alarm_admin");
  },
};
</script>
